import { toast, ToastContent, ToastOptions } from 'react-toastify'

export type ToastType = 'info' | 'success' | 'warning' | 'error'

export const triggerToast = (type: ToastType, text: ToastContent, options?: ToastOptions) => {
  let modifiedOptions = options

  if (options !== undefined) {
    if (options.autoClose === false) {
      modifiedOptions = { ...options, className: 'permanent-toast' }
    }
  }

  return toast[type](text, modifiedOptions)
}
